import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "../utils/getBaseUrl";

export const productMasterApi: any = createApi({
  reducerPath: "productMaster",
  baseQuery: fetchBaseQuery({
    // baseUrl: "http://localhost:3030/",
    baseUrl: getBaseUrl(),
  }),
  endpoints: (products) => ({
    getproductmaster: products.query<{}, any>({
      query: () =>
        //  "products",
        "/appService/productcontroller/getproductmaster",
    }),
    getcadenaimage: products.query<{}, any>({
      query: (articleNumber) =>
        `/getcadenaimagedetailsbyarticlenumber?articleNumber=${articleNumber}`,
    }),
  }),
});

export const { useGetproductmasterQuery, useGetcadenaimageQuery } =
  productMasterApi;
